import { AxiosResponse } from "axios";
import { WSPATRReportType } from "../../Model/Enum/BEE123Enums";
import { axiosWSPInstance } from "../AxiosWSPInterceptor";
import * as ApiUrls from "./ApiUrl.WSPDashboard";
import { CostAndInterventionFundingChartDto, CostAndHeadcountChartDto } from "../../Model/Dto/WSP/Dashboard";
import { ICostAndHeadcountPerTrainingType } from "../../Common/Components/Charts/WSP/CostAndHeadcountPerTrainingType";
import { SearchResult } from "../../Model/Dto/SearchResult";
import { WorkforceProfileOFOCodeSearchInput, WorkforceProfileOFOCodeSummary } from "../../Model/Dto/WSP/WorkforceProfileOFOCodeSummary";

export const WSPDashboardService = {
    GetFundingChart: (scorecardId: string, reportType: WSPATRReportType): Promise<AxiosResponse<CostAndInterventionFundingChartDto>> =>
        axiosWSPInstance.get(ApiUrls.FundingChart, { params: { scorecardId, reportType } }),
    GetTrainingChart: (scorecardId: string, reportType: WSPATRReportType): Promise<AxiosResponse<ICostAndHeadcountPerTrainingType>> =>
        axiosWSPInstance.get(ApiUrls.TrainingChart, { params: { scorecardId, reportType } }),

    GetWorkforceProfileOFOCodeSummary: (scorecardId: string): Promise<AxiosResponse<WorkforceProfileOFOCodeSummary[]>> =>
        axiosWSPInstance.get(ApiUrls.WorkforceProfileOFOCodeSummary, { params: { scorecardId } }),
    SearchWorkforceProfileOFOCodeSummary: (searchInput: WorkforceProfileOFOCodeSearchInput): Promise<AxiosResponse<SearchResult<WorkforceProfileOFOCodeSummary>>> =>
        axiosWSPInstance.post(ApiUrls.WorkforceProfileOFOCodeSummarySearch, searchInput),

    GetOFOCodeChart: (scorecardId: string, reportType: WSPATRReportType): Promise<AxiosResponse<CostAndHeadcountChartDto>> =>
        axiosWSPInstance.get(ApiUrls.OFOCodeChart, { params: { scorecardId, reportType } }),
}